module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAaCAYAAABGiCfwAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD4SURBVHgBxZWNEYIwDIUfTuAIHYERGMERGIENxA3cAJ3AEWADR6gb4AbPIL0TxVJ+onx3ObheyGuT0ABrQzIR2+GXiIARK/niKraFNhI0FqvZp4A2EtTSTwYtXI2GqDXSuRnp1wjl0KDZNcMsPt3zZFEU3eVRBXxV03gO+B7cpnT4+MfeUghtAl1poI0EPXrESmjjOtN6BPfQhu3VxX8KpgOCl24N5T1zawXn1lY+zDlME7z0rBtMZYSgDyuWYiouTXOZXmO2TWM5jwRTYX+Sj8VgLmzTakcKLZ/07pSngJCl5jXXEa2/CMVd3wiKsG0EI3aTcVRhTR5lrxnc4FiASQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/Images/callicons.png
// module id = 1129
// module chunks = 0